import React, { useRef, useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const CountDownVideo = ({ videoSource, onVideoEnd, isSoundOn, volume }) => {
  const videoRef = useRef(null);
  const [showShutter, setShowShutter] = useState(true);
  const [audio_shutter] = useState(new Audio('sound/button_sound/Main_Start.ogg'));


  useEffect(() => {
    audio_shutter.play();
    if (isSoundOn) {
      audio_shutter.volume = volume / 100;
    } else {
      audio_shutter.volume = 0;
    }
  }, [isSoundOn, volume]);

  const handleVideoEnd = () => {
    // When the video ends, trigger the onVideoEnd callback
    onVideoEnd();
  };

  useEffect(() => {
    const shutterImage = document.querySelector('.shutter-image');

    // Function to hide shutter image after animation
    const hideShutter = () => {
      setShowShutter(false);
    };

    // Add event listener to detect when the dropDownEffect animation ends
    shutterImage.addEventListener('animationend', hideShutter);

    return () => {
      // Remove event listener when component unmounts
      shutterImage.removeEventListener('animationend', hideShutter);
    };
  }, []);

  useEffect(() => {
    // Play the video when showShutter becomes false
    if (!showShutter && videoRef.current) {
      videoRef.current.play();
    }
  }, [showShutter]);
  

  return (
    <div className="preloading-start-selection-container">
      <Header />
      <Footer />
      {showShutter && (
        <div className="shutter-image"></div>
      )}
      <video
        ref={videoRef}
        src={videoSource}
        muted
        onEnded={handleVideoEnd}
        className={`preloading-start-selection ${showShutter ? 'hidden' : ''}`}
      >
        Your browser does not support the video tag.
      </video>
      <div className="animation-board"></div>
    </div>
  );
};

export default CountDownVideo;
